import { create } from "zustand";
import axios from "../helper/axios";

const useAuthStore = create((set) => ({

    userLogout: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/logout/${userData.qhoid}/${userData.qhuid}`
            );
            //console.log(response.data.name); 
            //console.log(response.data.status);
        } catch (err) {
            console.error(err);
        }
    }, 
    nujobsUserLogout: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nujobslogout/${userData.nujoid}/${userData.nujuid}`
            );
            //console.log(response.data.name); 
            //console.log(response.data.status);
        } catch (err) {
            console.error(err);
        }
    },       
}));

export default useAuthStore;
